import Overlay from 'ol/Overlay';
export default {
  methods: {
    initOverlay() {
      const container = document.getElementById('the-identification-overlay');
      this.overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
        positioning: 'bottom-center',
        offset: [0, -10],
      });
    },
  },
  watch: {
    pointerCoords: {
      handler(nV) {
        if (nV?.length && this.hoveredFeature) {
          this.overlay.setPosition(nV);
        } else {
          this.overlay.setPosition(undefined);
        }
      },
      deep: true,
    },
  },
};
